// extracted by mini-css-extract-plugin
export var Footer = "footer-module--Footer--20BeV";
export var Address = "footer-module--Address--kteVI";
export var AddressLink = "footer-module--AddressLink--1PpqX";
export var AddressHeart = "footer-module--AddressHeart--1feoa";
export var Copyrights = "footer-module--Copyrights--1HeWG";